import { render, staticRenderFns } from "./CheckMessage.vue?vue&type=template&id=3838bd3e&scoped=true&"
import script from "./CheckMessage.vue?vue&type=script&lang=js&"
export * from "./CheckMessage.vue?vue&type=script&lang=js&"
import style0 from "./CheckMessage.vue?vue&type=style&index=0&id=3838bd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838bd3e",
  null
  
)

export default component.exports